import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
export const ContactSection = () => {
  return <section id="contact" className="py-20 bg-gray-50" data-id="element-30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="text-center mb-16" data-id="element-32">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-33">
            Get In Touch
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-34">
            Ready to transform your business with our cloud and AI solutions?
            Contact us today for a consultation.
          </p>
        </div>
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-35">
          <div className="lg:w-1/2" data-id="element-36">
            <form className="space-y-6" data-id="element-37">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-38">
                <div data-id="element-39">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-40">
                    Name
                  </label>
                  <input type="text" id="name" name="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Your name" data-id="element-41" />
                </div>
                <div data-id="element-42">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-43">
                    Email
                  </label>
                  <input type="email" id="email" name="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="your.email@example.com" data-id="element-44" />
                </div>
              </div>
              <div data-id="element-45">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-46">
                  Subject
                </label>
                <input type="text" id="subject" name="subject" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="How can we help you?" data-id="element-47" />
              </div>
              <div data-id="element-48">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-49">
                  Message
                </label>
                <textarea id="message" name="message" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Tell us about your project or inquiry..." data-id="element-50"></textarea>
              </div>
              <div data-id="element-51">
                <button type="submit" className="w-full bg-blue-600 text-white py-3 px-6 rounded-md hover:bg-blue-700 transition-colors font-medium" data-id="element-52">
                  Send Message
                </button>
              </div>
            </form>
          </div>
          <div className="lg:w-1/2" data-id="element-53">
            <div className="bg-white p-8 rounded-lg shadow-md h-full" data-id="element-54">
              <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-55">
                Contact Information
              </h3>
              <div className="space-y-6" data-id="element-56">
                <div className="flex items-start" data-id="element-57">
                  <div className="flex-shrink-0 mt-1" data-id="element-58">
                    <Mail size={20} className="text-blue-600" data-id="element-59" />
                  </div>
                  <div className="ml-4" data-id="element-60">
                    <h4 className="text-lg font-medium text-gray-900" data-id="element-61">Email</h4>
                    <p className="text-gray-600" data-id="element-62">
                      contact@dynoroot.com
                    </p>
                  
                  </div>
                </div>
                <div className="flex items-start" data-id="element-63">
                  <div className="flex-shrink-0 mt-1" data-id="element-64">
                    <Phone size={20} className="text-blue-600" data-id="element-65" />
                  </div>
                  <div className="ml-4" data-id="element-66">
                    <h4 className="text-lg font-medium text-gray-900" data-id="element-67">Phone</h4>
                    <p className="text-gray-600" data-id="element-68">+91 (939) 085 - 5388</p>
                   </div>
                </div>
                <div className="flex items-start" data-id="element-69">
                  <div className="flex-shrink-0 mt-1" data-id="element-70">
                    <MapPin size={20} className="text-blue-600" data-id="element-71" />
                  </div>
                  <div className="ml-4" data-id="element-72">
                    <h4 className="text-lg font-medium text-gray-900" data-id="element-73">
                      Office
                    </h4>
                    <p className="text-gray-600" data-id="element-74">Bengaluru, India</p>
                   
                  </div>
                </div>
              </div>
              <div className="mt-8" data-id="element-75">
                <h4 className="text-lg font-medium text-gray-900 mb-4" data-id="element-76">
                  Business Hours
                </h4>
                <div className="space-y-2" data-id="element-77">
                  <div className="flex justify-between" data-id="element-78">
                    <span className="text-gray-600" data-id="element-79">Monday - Saturday:</span>
                    <span className="text-gray-900" data-id="element-80">9:00 AM - 6:00 PM</span>
                  </div>
                
                  <div className="flex justify-between" data-id="element-81">
                    <span className="text-gray-600" data-id="element-82">Sunday:</span>
                    <span className="text-gray-900" data-id="element-83">Closed</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};